module.exports = __webpack_public_path__ + "img/MenonN.42c17051.jpg";